var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseAction',[_c('PrimaryButton',{attrs:{"full-width":_vm.isMobile},nativeOn:{"click":function($event){return _vm.openDialog.apply(null, arguments)}}},[_vm._v(" Add Assessment ")]),_c('AssessmentDialog',{attrs:{"isOpen":_vm.isOpen,"applications":_vm.applications},on:{"close":_vm.closeDialog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }